export const vpsPlansBrSsd = [
  {
    name: "VPS BR SSD 3GB",
    audience: "Para projetos leves, sites em crescimento e ambientes de teste.",
    price: "69,90",
    unit: "/mês",
    badge: "Melhor custo-benefício",
    badgeTone: "primary",
    highlighted: false,
    specs: [
      { label: "Memória", value: "3 GB RAM" },
      { label: "Disco", value: "40 GB SSD" },
      { label: "CPU", value: "1x 1.8 GHz" },
      { label: "Tráfego", value: "100 GB (link 50 Mbit)" },
    ],
    features: [
      "Painel DirectAdmin opcional",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS BR SSD 8GB",
    audience: "Para sistemas em produção que exigem mais recursos e estabilidade.",
    price: "139,90",
    unit: "/mês",
    highlighted: true,
    badge: "Mais escolhido",
    specs: [
      { label: "Memória", value: "8 GB RAM" },
      { label: "Disco", value: "100 GB SSD" },
      { label: "CPU", value: "1x 3.7 GHz (ou 2x 1.85 GHz)" },
      { label: "Tráfego", value: "1.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS BR SSD 16GB",
    audience: "Para operações com alto volume de acessos e processamento.",
    price: "350,00",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "16 GB RAM" },
      { label: "Disco", value: "200 GB SSD" },
      { label: "CPU", value: "2x 3.7 GHz (ou 4x 1.85 GHz)" },
      { label: "Tráfego", value: "2.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS BR SSD 32GB",
    audience: "Para cargas pesadas, e-commerce de grande porte e aplicações críticas.",
    price: "559,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "400 GB SSD" },
      { label: "CPU", value: "4x 3.7 GHz (ou 8x 1.85 GHz)" },
      { label: "Tráfego", value: "4.000 GB (link 500 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
];

export const vpsPlansEuaSsd = [
  {
    name: "VPS EUA SSD 3GB",
    audience: "Para projetos leves, sites em crescimento e ambientes de teste.",
    price: "69,90",
    unit: "/mês",
    badge: "Melhor custo-benefício",
    badgeTone: "primary",
    highlighted: false,
    specs: [
      { label: "Memória", value: "3 GB RAM" },
      { label: "Disco", value: "40 GB SSD" },
      { label: "CPU", value: "1x 1.8 GHz" },
      { label: "Tráfego", value: "500 GB (link 300 Mbit)" },
    ],
    features: [
      "Painel DirectAdmin opcional",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS EUA SSD 8GB",
    audience: "Para sistemas em produção que exigem mais recursos e estabilidade.",
    price: "139,90",
    unit: "/mês",
    highlighted: true,
    badge: "Mais escolhido",
    specs: [
      { label: "Memória", value: "8 GB RAM" },
      { label: "Disco", value: "100 GB SSD" },
      { label: "CPU", value: "1x 3.7 GHz (ou 2x 1.85 GHz)" },
      { label: "Tráfego", value: "2.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS EUA SSD 16GB",
    audience: "Para operações com alto volume de acessos e processamento.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "16 GB RAM" },
      { label: "Disco", value: "200 GB SSD" },
      { label: "CPU", value: "2x 3.7 GHz (ou 4x 1.85 GHz)" },
      { label: "Tráfego", value: "4.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
  {
    name: "VPS EUA SSD 32GB",
    audience: "Para cargas pesadas, streaming e aplicações de grande tráfego.",
    price: "559,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "32 GB RAM" },
      { label: "Disco", value: "400 GB SSD" },
      { label: "CPU", value: "4x 3.7 GHz (ou 8x 1.85 GHz)" },
      { label: "Tráfego", value: "8.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
      "100% SSD RAID10",
    ],
  },
];

export const vpsPlansBrHd = [
  {
    name: "VPS BR 4GB",
    audience: "Alternativa econômica para aplicações pequenas e médias.",
    price: "139,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "4 GB RAM" },
      { label: "Disco", value: "125 GB HD" },
      { label: "CPU", value: "1x 3.4 GHz (ou 2x 1.7 GHz)" },
      { label: "Tráfego", value: "100 GB (link 100 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
  {
    name: "VPS BR 8GB",
    audience: "Para sistemas que precisam de mais memória sem subir muito o custo.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "8 GB RAM" },
      { label: "Disco", value: "250 GB HD" },
      { label: "CPU", value: "2x 3.4 GHz (ou 4x 1.7 GHz)" },
      { label: "Tráfego", value: "200 GB (link 100 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
  {
    name: "VPS BR 16GB",
    audience: "Para aplicações com demanda constante de processamento.",
    price: "559,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "16 GB RAM" },
      { label: "Disco", value: "500 GB HD" },
      { label: "CPU", value: "4x 3.4 GHz (ou 8x 1.7 GHz)" },
      { label: "Tráfego", value: "400 GB (link 100 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
];

export const vpsPlansEuaHd = [
  {
    name: "VPS EUA 4GB",
    audience: "Alternativa econômica com grande largura de banda internacional.",
    price: "139,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "4 GB RAM" },
      { label: "Disco", value: "125 GB HD" },
      { label: "CPU", value: "1x 3.4 GHz (ou 2x 1.7 GHz)" },
      { label: "Tráfego", value: "1.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
  {
    name: "VPS EUA 8GB",
    audience: "Para sistemas que precisam de mais memória com bom tráfego mensal.",
    price: "279,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "8 GB RAM" },
      { label: "Disco", value: "250 GB HD" },
      { label: "CPU", value: "2x 3.4 GHz (ou 4x 1.7 GHz)" },
      { label: "Tráfego", value: "2.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
  {
    name: "VPS EUA DA 8GB",
    audience: "Mais processamento e tráfego para aplicações exigentes.",
    price: "559,90",
    unit: "/mês",
    highlighted: false,
    specs: [
      { label: "Memória", value: "8 GB RAM" },
      { label: "Disco", value: "500 GB HD" },
      { label: "CPU", value: "4x 3.2 GHz (ou 8x 1.6 GHz)" },
      { label: "Tráfego", value: "4.000 GB (link 1.000 Mbit)" },
    ],
    features: [
      "DirectAdmin ou cPanel opcionais",
      "vCore de CPU 100% garantido",
    ],
  },
];

export const vpsPlans = [
  ...vpsPlansBrSsd,
  ...vpsPlansEuaSsd,
  ...vpsPlansBrHd,
  ...vpsPlansEuaHd,
];

export const vpsTechnical = [
  {
    icon: "ri-flashlight-line",
    title: "Armazenamento NVMe",
    description: "Discos de alta velocidade para respostas rápidas em leitura e escrita.",
  },
  {
    icon: "ri-cpu-line",
    title: "Recursos dedicados",
    description: "vCPU e memória reservados para o seu projeto, sem compartilhamento.",
  },
  {
    icon: "ri-global-line",
    title: "IP dedicado",
    description: "Endereço próprio para configuração de serviços e aplicações.",
  },
  {
    icon: "ri-database-2-line",
    title: "Backups e snapshots",
    description: "Estrutura preparada para proteger e restaurar os seus dados quando precisar.",
  },
  {
    icon: "ri-terminal-box-line",
    title: "Acesso root total",
    description: "Liberdade para instalar e configurar o ambiente do seu jeito.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Proteção de rede",
    description: "Camadas de segurança para manter o seu ambiente protegido.",
  },
];

export const vpsUseCases = [
  {
    icon: "ri-shopping-bag-3-line",
    title: "E-commerce",
    description: "Lojas virtuais que precisam de velocidade e estabilidade em picos de venda.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Aplicações e sistemas",
    description: "Sistemas web e APIs com demanda constante de processamento.",
  },
  {
    icon: "ri-window-line",
    title: "Ambientes e testes",
    description: "Espaço isolado para desenvolvimento, homologação e testes.",
  },
  {
    icon: "ri-gamepad-line",
    title: "Servidores de aplicação",
    description: "Serviços específicos que exigem configuração personalizada.",
  },
];

export const vpsFaqs = [
  {
    question: "O que é um VPS e para quem ele é indicado?",
    answer:
      "VPS é um servidor virtual privado com recursos dedicados. É indicado para projetos que precisam de mais controle, desempenho e flexibilidade do que uma hospedagem compartilhada.",
  },
  {
    question: "Consigo administrar o VPS por conta própria?",
    answer:
      "Sim. Você recebe acesso root completo e pode instalar e configurar o ambiente como preferir. Se preferir, a nossa equipe também pode auxiliar na configuração.",
  },
  {
    question: "Os recursos podem ser ampliados depois?",
    answer:
      "Sim. Conforme o seu projeto cresce, é possível ajustar os recursos do VPS para acompanhar a nova demanda.",
  },
  {
    question: "O VPS inclui backups?",
    answer:
      "Sim. A estrutura conta com backups e snapshots. Fale com um especialista para conhecer as opções e frequências disponíveis.",
  },
  {
    question: "Vocês ajudam na migração para o VPS?",
    answer:
      "Sim. A nossa equipe orienta e acompanha a migração do seu projeto para o VPS, buscando manter tudo funcionando durante a transição.",
  },
];